/**
 * Leaflet integration helpers.
 *
 * Default Leaflet marker icons rely on relative paths that break inside CRA's
 * webpack build. We override the icon defaults to use unpkg-hosted PNGs and
 * also expose a brand-coloured custom marker (a green hex pin), used by the
 * "Onde Estamos" page so points-of-sale stand out.
 */
import L from "leaflet";

// Fix: default marker icons in Leaflet break under webpack (paths point to a
// non-existent prefix). Re-bind to absolute CDN URLs.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Brand-coloured drop pin (SVG -> divIcon). Uses the green primary colour.
const brandPinSVG = (color = "#2D9E3A", scale = 1) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 44" width="${
    32 * scale
}" height="${44 * scale}">
  <defs>
    <filter id="ds" x="-20%" y="-20%" width="140%" height="140%">
      <feDropShadow dx="0" dy="2" stdDeviation="1.5" flood-opacity="0.35"/>
    </filter>
  </defs>
  <path filter="url(#ds)" d="M16 1C7.7 1 1 7.6 1 15.7c0 11 15 27.3 15 27.3S31 26.7 31 15.7C31 7.6 24.3 1 16 1Z" fill="${color}" stroke="white" stroke-width="2"/>
  <circle cx="16" cy="15" r="6" fill="white"/>
</svg>`;

export const brandIcon = (color = "#2D9E3A", scale = 1) =>
    L.divIcon({
        className: "sl-marker",
        html: brandPinSVG(color, scale),
        iconSize: [32 * scale, 44 * scale],
        iconAnchor: [16 * scale, 44 * scale],
        popupAnchor: [0, -40 * scale],
    });

export default L;
